import { combineReducers } from 'redux'

import registerReducer, * as fromRegister from './reducer.register'

export default combineReducers({
	register: registerReducer,
})

// State accessors

export const getRequestingActivityPackStatus = state => fromRegister.getRequestingActivityPackStatus(state.register)
export const getRequestActivityPackError = state => fromRegister.getRequestActivityPackError(state.register)
